import React, { useEffect, useState } from 'react'
import { Snackbar, makeStyles } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import { t } from 'ttag'
import { isNative } from '../../common/helpers/isNative'

const useStyles = makeStyles((theme) => ({
  snackbar: {
    zIndex: 9999,
  },
  mobileSnackbar: {
    // Show right above bottom menu (61px) but don't hide it
    bottom: 'calc(60px + 10px) !important',
    // Handle iOS safe area insets
    '@supports (bottom: constant(safe-area-inset-bottom))': {
      bottom: 'calc(constant(safe-area-inset-bottom) - 14px + 60px + 10px) !important',
    },
    '@supports (bottom: env(safe-area-inset-bottom))': {
      bottom: 'calc(env(safe-area-inset-bottom) - 14px + 60px + 10px) !important',
    },
  },
}))

/**
 * Component that displays a Snackbar when the user is offline
 * Uses navigator.onLine to detect network status and shows a persistent alert until connection is restored
 */
const OfflineSnackbar: React.FC = () => {
  const classes = useStyles()
  const [isOffline, setIsOffline] = useState(!navigator.onLine)
  const [isMobile, setIsMobile] = useState(isNative() || window.innerWidth < 992)

  useEffect(() => {
    // Function to update online status
    const handleOnlineStatusChange = () => {
      setIsOffline(!navigator.onLine)
    }

    // Function to update mobile detection on window resize
    const handleResize = () => {
      setIsMobile(isNative() || window.innerWidth < 992)
    }

    // Add event listeners
    window.addEventListener('online', handleOnlineStatusChange)
    window.addEventListener('offline', handleOnlineStatusChange)
    window.addEventListener('resize', handleResize)

    // Initial check
    handleOnlineStatusChange()
    handleResize()

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener('online', handleOnlineStatusChange)
      window.removeEventListener('offline', handleOnlineStatusChange)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <>
      <Snackbar
        open={isOffline}
        className={`${classes.snackbar} ${isMobile ? classes.mobileSnackbar : ''}`}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        message={t`You're offline. Check your network settings.`}
      />
    </>
  )
}

export default OfflineSnackbar
